// mock.js — importe les données depuis contenu.js
// Ne pas modifier ce fichier, modifiez contenu.js à la place
import contenu from './contenu';

export const mockData = {
  services: contenu.services,
  gallery: [
    { id: 1,  url: "/images/paella.jpg",   title: "Paella aux fruits de mer",   category: "plats"    },
    { id: 2,  url: "/images/paella2.jpg",  title: "Paella traditionnelle",      category: "plats"    },
    { id: 3,  url: "/images/paella3.jpg",  title: "Paella en cuisson",          category: "plats"    },
    { id: 4,  url: "/images/porc.jpg",     title: "Cochon à la broche",         category: "viandes"  },
    { id: 5,  url: "/images/porc2.jpg",    title: "Cochon entier rôti",         category: "viandes"  },
    { id: 6,  url: "/images/bob2.jpg",     title: "Préparation en direct",      category: "viandes"  },
    { id: 7,  url: "/images/buffet2.jpg",  title: "Mini burgers & verrines",    category: "buffets"  },
    { id: 8,  url: "/images/buffet3.jpg",  title: "Buffet cocktail",            category: "buffets"  },
    { id: 9,  url: "/images/buffet4.jpg",  title: "Préparation des entrées",    category: "buffets"  },
    { id: 10, url: "/images/buffet5.jpg",  title: "Mini burgers maison",        category: "buffets"  },
  ],
  about: {
    title:       contenu.apropos.titre,
    description: contenu.apropos.description,
    values:      contenu.apropos.valeurs,
  },
};

export const submitBooking = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => { resolve({ success: true, message: 'Demande envoyée avec succès !' }); }, 1000);
  });
};
